document.querySelectorAll('.cosmetics-6')[1].style.display="none";
document.querySelectorAll('.accessories-7')[1].style.display="none";
document.querySelectorAll('.footwear-8')[1].style.display="none";
document.querySelectorAll('.girl-9')[1].style.display="none";
document.querySelectorAll('.men-10')[1].style.display="none";


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    
  }

  onButtonClick(event) {
    event.preventDefault();    
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);    
  }
  
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
     
      
    } else {

      document.querySelectorAll('.mob-third-level-parent').forEach((value, index)=>{
        value.closest('details').removeAttribute('open');
      });
      
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      
      
      
      
      setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      
      if(isOpen == true){
        detailsElement.removeAttribute('open');
      }
      
      
      let all_main_menu_child = document.querySelectorAll('.child-menu-main');
      for(let i=0; i<all_main_menu_child.length; i++){
        if(all_main_menu_child[i].hasAttribute('open')){
          //         debugger;
          all_main_menu_child[i].querySelector('summary').querySelector('.mobile-icon-plus').innerHTML = '-';
          
        }
        else{
          //         debugger;
          all_main_menu_child[i].querySelector('summary').querySelector('.mobile-icon-plus').innerHTML = '+';
        }
      }
      
    });
   
    }



  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } 
    else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      
      let variant_master_selectors = JSON.parse(document.querySelector('.varinats_master_selector').innerHTML);
      for(let i=0; i<variant_master_selectors.length; i++){
        if(variant_master_selectors[i].id == this.currentVariant.id){
        	document.querySelector('.cstm-variant-sku-code').innerHTML = variant_master_selectors[i].sku;
        }
      	
      }

    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    
    
    
    
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
      
      // Currency
      if (cookieCurrency == null) {
        if (shopCurrency !== defaultCurrency) {
          Currency.convertAll(shopCurrency, defaultCurrency);
        }
        else {
          Currency.currentCurrency = defaultCurrency;
        }
      }
      // If the cookie value does not correspond to any value in the currency dropdown.
      else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
        Currency.currentCurrency = shopCurrency;
        Currency.cookie.write(shopCurrency);
      }
      else if (cookieCurrency === shopCurrency) {
        Currency.currentCurrency = shopCurrency;
      }
      else {
        Currency.convertAll(shopCurrency, cookieCurrency);
      }

      var newCurrency = jQuery('#currencies').val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      jQuery('.selected-currency').text(Currency.currentCurrency);

//     On Option Update show free delivery only for pkr  
      let current_currency_text = document.querySelector('#currencies').value;
      if(current_currency_text != 'PKR'){
        if(document.querySelectorAll('.free-delivery-main').length > 0){
          document.querySelector('.free-delivery-main').style.display = 'none';
        }
      }
      else if(document.querySelectorAll('.free-delivery-main').length > 0){
        document.querySelector('.free-delivery-main').style.display = 'block';
      }
      
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      
    });
  }
}

customElements.define('variant-radios', VariantRadios);


// Add overflow hidden on body when any menu is open

let parent_menu = document.querySelectorAll('.menu-parent');

// for(let i=0; i<parent_menu.length; i++){
//   parent_menu[i].addEventListener('click', function(){
//     if(!(parent_menu[i].closest('details').hasAttribute('open'))){
//        	document.querySelector('body').style.overflow = "hidden";
       
//     }
//     else{
//     	document.querySelector('body').style.overflow = "initial";
//     }
//   })
// }


// Custom JS

// Change image on hover of megamenu child

let meu_child_link = document.querySelectorAll('.menu-child-link');

for(let i=0;i <meu_child_link.length; i++){
  meu_child_link[i].addEventListener('mouseover', function(){
  meu_child_link[i].closest('.menu-child-wrapper-main').querySelector('.org-menu-img').setAttribute('src',meu_child_link[i].getAttribute('img-src'));
  })
}


// Show menu on hover only desktop
const mainMenuMediaQuery = window.matchMedia('(min-width: 991px)')



  let main_menu_parent = document.querySelectorAll('.parent-main-menu');

  for(let i=0; i<main_menu_parent.length; i++){
    if(mainMenuMediaQuery.matches){

      //    Mouse over 
      main_menu_parent[i].addEventListener('mouseover', function(){
        main_menu_parent[i].setAttribute('open', '');
        document.querySelector('main').classList.add('menu-overlay');

        main_menu_parent.forEach((value, index)=>{
          value.querySelector('.header__menu-item').style.color = "gray";
        });

        main_menu_parent[i].querySelector('.header__menu-item').style.color = "#000";

      });

      main_menu_parent[i].addEventListener('click', function(){
        document.querySelector('main').classList.toggle('menu-overlay');

      });

      //     Mouse Leave
      main_menu_parent[i].addEventListener('mouseleave', function(){
        main_menu_parent[i].removeAttribute('open');
        document.querySelector('main').classList.remove('menu-overlay');

        main_menu_parent.forEach((value, index)=>{
          value.querySelector('.header__menu-item').style.color = "#000";
        });
      });
    }
    
//    On mobile 
    else{
      
      main_menu_parent[i].addEventListener('click', function(){
        if(main_menu_parent[i].hasAttribute('open')){
          
          console.log(main_menu_parent[i])
          console.log('Auto')
          document.body.style.overflow = 'auto';
          
          document.querySelector('main').classList.remove('menu-overlay-nav');
          document.querySelector('main').style.pointerEvents = "initial";
          
          main_menu_parent.forEach((value, index)=>{
            value.querySelector('.header__menu-item').style.color = "#000";
          });
          
        }
        else{

          console.log(main_menu_parent[i])
          console.log('hidden')
          document.body.style.overflow = 'hidden';
          
          document.querySelector('main').classList.add('menu-overlay-nav');
          document.querySelector('main').style.pointerEvents = "none";
          
          main_menu_parent.forEach((value, index)=>{
            value.querySelector('.header__menu-item').style.color = "gray";
          });

          main_menu_parent[i].querySelector('.header__menu-item').style.color = "#000";
        }

      });


    }
}



let current_url = window.location.pathname;
// Load More Button

if(current_url.includes('collections')){
  if(document.querySelectorAll('#main-collection-product-grid').length > 0){
  let products_on_page = document.getElementById("main-collection-product-grid");
  let next_url = products_on_page.getAttribute('data-next-url');
  let loadmore_btn = document.querySelector(".load-more-cstm-btn");
  let loadmore_spinner = document.querySelector(".load-more-spinner");
  let no_more = document.querySelector(".no-more-cstm");


  var loadMoreProducts = function (){ 

    fetch(next_url)
    .then((response)=>{
      loadmore_btn.style.display = "none";
      loadmore_spinner.style.display = "block";
      return response.text();
    })

    .then((data)=>{
      
      

      var parser = new DOMParser();
      var doc = parser.parseFromString(data, 'text/html');
      let return_html = doc.body;
      let main_html = return_html.querySelector('#main-collection-product-grid');
//       console.log(main_html);
      let main_html_child = main_html.querySelectorAll('.grid__item');
      let new_url = main_html.getAttribute('data-next-url');
      console.log(new_url);

      loadmore_spinner.style.display = "none";

      if(new_url){
        loadmore_spinner.style.display = "block";
        loadmore_btn.style.display = "none";
        

      }
      
      


      next_url = new_url;

//       setTimeout(()=>{
      
      // var clickData = localStorage.getItem("lastClick");          
      
      main_html_child.forEach(function(value, index){
        
        document.querySelector('.products-on-page').append(value);

      //   var currClick = value.querySelector('a').getAttribute('href');
      //   var currClickSplit = currClick.split('/');
      //   if (currClickSplit[4] == clickData) {
      //     return false;            
      //   } else {
      //     var top = value.offsetTop + value.offsetHeight;
      //     console.log(top, value.offsetTop, value.offsetHeight)
      //     $('html,body').animate({scrollTop: top}, 10);
      //   }

      })
      
      
      if (cookieCurrency == null) {
        if (shopCurrency !== defaultCurrency) {
          Currency.convertAll(shopCurrency, defaultCurrency);
        }
        else {
          Currency.currentCurrency = defaultCurrency;
        }
      }
      // If the cookie value does not correspond to any value in the currency dropdown.
      else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
        Currency.currentCurrency = shopCurrency;
        Currency.cookie.write(shopCurrency);
      }
      else if (cookieCurrency === shopCurrency) {
        Currency.currentCurrency = shopCurrency;
      }
      else {
        Currency.convertAll(shopCurrency, cookieCurrency);
      }

      var newCurrency = jQuery('#currencies').val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      jQuery('.selected-currency').text(Currency.currentCurrency);
      
      
      loadmore_spinner.style.display = "none";
      if(new_url){
        loadmore_btn.style.display = "block";
      }
      else{
        loadmore_btn.style.display = "none";
        no_more.style.display = "block";
      }

//     },600)



  })

  .catch((err)=>{
    console.log(err);
  })

}


// Load More Function Call
  if(document.querySelectorAll('.load-more-cstm-btn').length > 0){
    document.querySelector('.load-more-cstm-btn').addEventListener('click', ()=>{
     loadMoreProducts()
  });
  }


// Grid style

let simple_style = document.getElementById('two-style');
let pyramid_style = document.getElementById('pyramid-style');
let collection_grid_cstm = document.getElementById('main-collection-product-grid');

simple_style.addEventListener('click', function(){
  collection_grid_cstm.classList.add('simple-style-grid');
  collection_grid_cstm.classList.remove('pyramid-style-grid');
});

pyramid_style.addEventListener('click', function(){
  collection_grid_cstm.classList.add('pyramid-style-grid');
  collection_grid_cstm.classList.remove('simple-style-grid');

});

// Filters view all on page refresh
function showViewAl(){
  let current_filter_url = window.location.href;
  if(current_filter_url.includes('filter')){
    document.querySelector('#view-all-btn-des').style.cssText = "opacity: 1 ; pointer-events: initial";
    document.querySelector('#view-all-btn-mob').style.cssText = "opacity: 1 ; pointer-events: initial";
  }
  else{
    document.querySelector('#view-all-btn-des').style.cssText = "opacity: 0.4 ; pointer-events: none";
    document.querySelector('#view-all-btn-mob').style.cssText = "opacity: 0.4 ; pointer-events: none";
  }

}

showViewAl();

}

}

// Change vendor text to season

let filter_text = document.querySelectorAll('.cstm-facet-text');
for (let i=0; i<filter_text.length; i++){
  if(filter_text[i].innerHTML == 'Brand'){
  	filter_text[i].innerHTML = 'Season';
  }
  if(filter_text[i].innerHTML == 'Product type'){
    filter_text[i].innerHTML = 'Type';
  }
}


// get data on page load store on local storage

if (window.location.href.includes('collections')){
  //   let local_url = window.location.href;
  
//   PR
  
//   if(document.querySelectorAll('#CollectionProductGrid').length > 0){
//     let local_url = document.querySelector('#CollectionProductGrid').getAttribute('collection_url');

//     if(localStorage.getItem('data') == null){
//       localStorage.setItem('data', '[]');
//     }

//     let old_data = JSON.parse(localStorage.getItem('data'));


//     if(local_url.includes('filter') || local_url.includes('sort')){

//     }

//     else{

//       if(old_data.length <= 2){
//         if(old_data.includes(local_url) == false){
//           old_data.unshift(local_url);
//           localStorage.setItem('data', JSON.stringify(old_data));
//         }
//       }

//       else if(old_data.length > 2){
//         if(old_data.includes(local_url) == false){
//           old_data.pop();
//           old_data.unshift(local_url);
//           localStorage.setItem('data', JSON.stringify(old_data));
//         }
//       }

//     }
//   }
  
//   Hide vendor limelight showing as season
  let all_filter_facets_head = document.querySelectorAll('.cstm-facet-text');
  for(let i=0; i<all_filter_facets_head.length; i++){
    if(all_filter_facets_head[i].innerHTML.toLowerCase() == 'season'){
      let all_facet_items = all_filter_facets_head[i].closest('.disclosure-has-popup').querySelectorAll('.facets__item');
      for(let j=0; j<all_facet_items.length; j++){
        if(all_facet_items[j].querySelector('.facet-checkbox').innerHTML.toLowerCase().includes('limelight')){
          all_facet_items[j].style.display = 'none';
        }
      }
    	
    }
  }

}

// PR

// fetching products

// if(window.location.pathname == '/'){
//   let current_recommended_item = [];
  
//   if(localStorage.getItem('data') != null){

//     document.querySelector('.recommended-products-main').classList.remove('hide-no-local-item');

//     let get_url_local = localStorage.getItem('data');
//     let new_get_url_local = JSON.parse(get_url_local);

//     for(let i=0; i<new_get_url_local.length; i++){


//       fetch(new_get_url_local[i])
//       .then((response)=>{
//         return response.text();
//       })

//       .then((data)=>{

//         var parser = new DOMParser();
//         var doc = parser.parseFromString(data, 'text/html');
//         let return_html = doc.body;
//         let main_html = return_html.querySelector('#main-collection-product-grid');
//         let main_html_child = main_html.querySelectorAll('.grid__item');
        
        

//         setTimeout(()=>{
//                    main_html_child.forEach(function(value, index){
//           current_recommended_item.push(value);
//           document.querySelector('#recommended-products-grid').querySelector('.product-grid').append(value);
          
//           // Currency
//           if (cookieCurrency == null) {
//             if (shopCurrency !== defaultCurrency) {
//               Currency.convertAll(shopCurrency, defaultCurrency);
//             }
//             else {
//               Currency.currentCurrency = defaultCurrency;
//             }
//           }
//           // If the cookie value does not correspond to any value in the currency dropdown.
//           else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
//             Currency.currentCurrency = shopCurrency;
//             Currency.cookie.write(shopCurrency);
//           }
//           else if (cookieCurrency === shopCurrency) {
//             Currency.currentCurrency = shopCurrency;
//           }
//           else {
//             Currency.convertAll(shopCurrency, cookieCurrency);
//           }

//           var newCurrency = jQuery('#currencies').val();
//           Currency.convertAll(Currency.currentCurrency, newCurrency);
//           jQuery('.selected-currency').text(Currency.currentCurrency);

//         })

//       },600);
      
      
//     })

//     .catch((err)=>{
//       console.log(err);
//     })

//   }

// }
// }

if(window.matchMedia("(min-width: 751px)")){
  // phone icon on desktop

//   Showing phone popup
  document.querySelector('.phn-main-des').addEventListener('click', function(){
    document.querySelector('.phone-desktop-parent-main').style.display = "block";

    document.querySelector('main').classList.add('menu-overlay');
    document.querySelector('main').style.pointerEvents = "none";

    document.querySelector('footer').classList.add('menu-overlay');
    document.querySelector('footer').style.pointerEvents = "none";

    document.querySelector('.desktop-header-main').classList.add('menu-overlay');
    document.querySelector('.desktop-header-main').style.pointerEvents = "none";
  })
//  Closing phone popup
  
  document.querySelector('.phone-desktop-close-icon svg').addEventListener('click', function(){
    document.querySelector('.phone-desktop-parent-main').style.display = "none";

    document.querySelector('main').classList.remove('menu-overlay');
    document.querySelector('main').style.pointerEvents = "initial";

    document.querySelector('footer').classList.remove('menu-overlay');
    document.querySelector('footer').style.pointerEvents = "initial";


    document.querySelector('.desktop-header-main').classList.remove('menu-overlay');
    document.querySelector('.desktop-header-main').style.pointerEvents = "initial";
  })
}

// quickview

  function quickview(productHandle){

    let test = `/products/${productHandle}.js`;
    let xhttp = new XMLHttpRequest();
    let outer_price_org =  event.target.closest('.card-wrapper').querySelector('.card-information__wrapper .price');
    let clone_outer_price = outer_price_org.cloneNode(true);

    xhttp.onreadystatechange = function(product) {
      if (this.readyState == 4 && this.status == 200) {

        quickviewData(JSON.parse(this.response), clone_outer_price) 
      }
    };
    xhttp.open("GET", test , true);
    xhttp.send();    
  }

  function quickviewData(data, clone_outer_price) {

    // Dengage Add to Cart Integration Start
    
    console.log("Response Data: ", data);

    $('.quickview-info-main').attr('data-product-id', data.id)
    $('.quickview-info-main').attr('data-prod-var-id', data.variants[0].id)
    $('.quickview-info-main').attr('data-prod-price', data.price / 100)
    $('.quickview-info-main').attr('data-prod-disc-price', data.compare_at_price > data.price ? data.compare_at_price / 100 : data.price / 100);
    
    // Dengage Add to Cart Integration End

    
    //   Adding Product Link to view full details
    document.querySelector('#quickview-product-link').setAttribute('href', data.url)
    
    //   Displaying overlay div
    document.getElementById('quickview-popup-wrapper').style.display = "block";

    //   quickview product options
    let product_options = data.options;
    
    //   Quickview images
    let quickview_imgs = data.media;

    let featured_img_main = document.querySelector('.featured-img-main');

    let secondary_imgs = document.querySelector('.secondary-imgs');

    //  featured image
    let featured_img = document.createElement('img'); 
    featured_img.src = data.featured_image;
    featured_img.setAttribute('alt', quickview_imgs[0].alt);
    featured_img.setAttribute('var_id', quickview_imgs[0].id);
    featured_img.classList.add('featured-img');
    featured_img.setAttribute('id', 'featured-img');
    featured_img_main.appendChild(featured_img);
    
    let sec_img_length = '';
    if(quickview_imgs.length > 5){
      sec_img_length = +5;
    }
    else{
    	sec_img_length = Number(quickview_imgs.length);
    }

    // secondary images
    for(let i=0; i<sec_img_length; i++){
      let quick_img = document.createElement('img');
      quick_img.src = quickview_imgs[i].src;
      quick_img.alt = quickview_imgs[i].alt;
      quick_img.setAttribute('var_id', quickview_imgs[i].id);
      quick_img.classList.add('var_sec_img');
      secondary_imgs.appendChild(quick_img);
    }

    // change featured image onclcik of secondary img
    let sec_img = document.getElementsByClassName('var_sec_img');
    for(let i=0;i <sec_img.length; i++){
      sec_img[i].addEventListener('click', function(){
        let clicked_img_src = this.getAttribute('src');

        this.closest('.quickview-img').querySelector('.featured-img').setAttribute('src',clicked_img_src);
      })
    }



    //   Get info of product
    let documentFragment = document.createDocumentFragment();
    let quickview_info = document.querySelector('.quickview-info');

    //   Product title

    let product_title = document.createElement('h1');
    product_title.textContent  = data.title;
    product_title.setAttribute('data-tile', data.title);
    product_title.classList.add('product-title');  
    documentFragment.appendChild(product_title);

    //   Price and comapre at price

    let product_price_main = document.createElement('div');
    product_price_main.classList.add('product-price-main');
    documentFragment.appendChild(product_price_main);
    product_price_main.appendChild(clone_outer_price);


    //   Variant Swatch
    let variant_swatch_main = document.createElement('div');
    variant_swatch_main.classList.add('quickview-variant-swatch-main');

    documentFragment.appendChild(variant_swatch_main);


//     console.log(product_options.length);
    for(let i=0 ; i<product_options.length; i++){

      if((product_options[i].name.toLowerCase() != 'color') && (product_options[i].name.toLowerCase() != 'title')){
       
              //     Swatch Name
        let quickview_swatch_name = document.createElement('span');
        quickview_swatch_name.classList.add('quickview_swatch_name');
        quickview_swatch_name.innerHTML = product_options[i].name;

        variant_swatch_main.appendChild(quickview_swatch_name);

        //    Swatch Value
        let quickview_swatch_value_array = product_options[i].values;

        let quickview_swatch_value = document.createElement('div');
        quickview_swatch_value.classList.add('quickview_swatch_value');
        quickview_swatch_value.setAttribute('quickview-swatch', product_options[i].name);

        //     Adding Value
        for(let j=0 ;j<quickview_swatch_value_array.length; j++){
      
          let quickview_swatch_value_text = document.createElement('label');
          quickview_swatch_value_text.classList.add('quickview_swatch_value_text');
          if (( quickview_swatch_value_array[j].toLowerCase() == 'extra small' ) || ( quickview_swatch_value_array[j].toLowerCase() == 'small' ) || ( quickview_swatch_value_array[j].toLowerCase() == 'medium' ) || ( quickview_swatch_value_array[j].toLowerCase() == 'large' ) || ( quickview_swatch_value_array[j].toLowerCase() == 'extra large' )){
          	quickview_swatch_value_text.classList.add('size-sml');
          }
          else{
          	quickview_swatch_value_text.classList.add('size-other');
          }
          
          
          
          if ( quickview_swatch_value_array[j].toLowerCase() == 'extra small' ){
            quickview_swatch_value_text.innerHTML = "XS";
          }
          else if ( quickview_swatch_value_array[j].toLowerCase() == 'small' ){
            quickview_swatch_value_text.innerHTML = "S";
          }
          else if ( quickview_swatch_value_array[j].toLowerCase() == 'medium' ){
            quickview_swatch_value_text.innerHTML = "M";
          }
          else if ( quickview_swatch_value_array[j].toLowerCase() == 'large' ){
            quickview_swatch_value_text.innerHTML = "L";
          }
          else if ( quickview_swatch_value_array[j].toLowerCase() == 'extra large' ){
            quickview_swatch_value_text.innerHTML = "XL";
          }
          else{
          quickview_swatch_value_text.innerHTML = quickview_swatch_value_array[j];
          }
          
          let quickview_swatch_radio = document.createElement('input');
          quickview_swatch_radio.setAttribute('type', 'radio');
          quickview_swatch_radio.setAttribute('value', quickview_swatch_value_array[j]);
          quickview_swatch_radio.setAttribute('name', product_options[i].name);
          quickview_swatch_radio.classList.add('quickview_swatch_radio');

          quickview_swatch_value_text.appendChild(quickview_swatch_radio);
          quickview_swatch_value.appendChild(quickview_swatch_value_text);
        }
        variant_swatch_main.appendChild(quickview_swatch_value);
      
      }
      
//       for color and default title option in swatches
      else {
        //     Swatch Name
        let quickview_swatch_name = document.createElement('span');
        quickview_swatch_name.classList.add('quickview_swatch_name','hide-swatch-option');
        quickview_swatch_name.innerHTML = product_options[i].name;
        variant_swatch_main.appendChild(quickview_swatch_name);
        //    Swatch Value
        let quickview_swatch_value_array = product_options[i].values;
	  
        let quickview_swatch_value = document.createElement('div');
        quickview_swatch_value.classList.add('quickview_swatch_value','hide-swatch-option');
        quickview_swatch_value.setAttribute('quickview-swatch', product_options[i].name);

        //     Adding Value
        for(let j=0 ;j<quickview_swatch_value_array.length; j++){

          let quickview_swatch_value_text = document.createElement('label');
          quickview_swatch_value_text.classList.add('quickview_swatch_value_text', 'quickview-selected-swatch');
          quickview_swatch_value_text.innerHTML = quickview_swatch_value_array[j];  
          let quickview_swatch_radio = document.createElement('input');
          quickview_swatch_radio.setAttribute('type', 'radio');
          quickview_swatch_radio.setAttribute('value', quickview_swatch_value_array[j]);
          quickview_swatch_radio.setAttribute('name', product_options[i].name);
          quickview_swatch_radio.classList.add('quickview_swatch_radio');
          quickview_swatch_radio.checked = true;

          quickview_swatch_value_text.appendChild(quickview_swatch_radio);
          quickview_swatch_value.appendChild(quickview_swatch_value_text);
        }
        variant_swatch_main.appendChild(quickview_swatch_value);
      }


    }

//   adding 1 qty and add to cart text for other quickview
    document.getElementById('quickview_cart_qty').value = '1';
    document.getElementById('quickview-add-to-cart-btn').innerHTML = 'Add to Cart';
    

    //   Master Selector
    let masterSelectorOption = ''
    data.variants.forEach(function(value, index) {
      masterSelectorOption += `<option value="${ value.id }" master_title="${value.title}" class="variant_master_option" ${ value.available == true ? '' : 'disabled'}>${ value.title }</option>`
    })

    let masterSelectorSelect = document.createElement('select');

    masterSelectorSelect.setAttribute('name','id');
    masterSelectorSelect.setAttribute('id','quick-master');

    masterSelectorSelect.innerHTML = masterSelectorOption

//     console.log(masterSelectorSelect);

    documentFragment.appendChild(masterSelectorSelect);
    //   end master selector


    //   Append all elements to main quickview div
    quickview_info.appendChild(documentFragment);

    
//  all variants options array 

    let all_master_options = document.querySelectorAll('.variant_master_option');
//     console.log(all_master_options);
    
//   Selecting first available variant
    
    let first_avb_variants = '';
    for(let i=0; i<all_master_options.length; i++){
      if(all_master_options[i].hasAttribute('disabled') == false){
        first_avb_variants = all_master_options[i].getAttribute('master_title'); 
//       	console.log(first_avb_variants);
        break;
      }
      
    }

    let all_swatch_radio = document.querySelectorAll('.quickview_swatch_radio');
    for(let i=0; i<all_swatch_radio.length; i++){
      
      if(first_avb_variants.includes('/')){
        if(first_avb_variants.includes((all_swatch_radio[i]).value)){
          all_swatch_radio[i].closest('.quickview_swatch_value_text').classList.add('quickview-selected-swatch');
        }

      }
      else{
        if(first_avb_variants == all_swatch_radio[i].value){
          all_swatch_radio[i].closest('.quickview_swatch_value_text').classList.add('quickview-selected-swatch');
        }
      }
    }

    let quickview_swatch_radio_btn = document.querySelectorAll('.quickview_swatch_radio');
    for(let i=0;i <quickview_swatch_radio_btn.length; i++){

      quickview_swatch_radio_btn[i].closest('label').classList.remove('selected-swatch');

      quickview_swatch_radio_btn[i].addEventListener('click', function(){
        
        let current_swatch_values = quickview_swatch_radio_btn[i].closest('.quickview_swatch_value').querySelectorAll('.quickview_swatch_radio');
//         console.log(current_swatch_values);
        current_swatch_values.forEach((value, index)=>{
          value.closest('label').classList.remove('quickview-selected-swatch');
          if(value.checked){
            value.closest('label').classList.add('quickview-selected-swatch');
          }
        })
        
        
//      Show soldout
        
        let selected_swatch_qv = document.querySelectorAll('.quickview-selected-swatch input');
        let selected_swatch_qv_title = '';
        
        
        selected_swatch_qv.forEach((value, index)=>{

          selected_swatch_qv_title = selected_swatch_qv_title + ' / ' + value.getAttribute('value');
        })

        let selected_test_title = selected_swatch_qv_title;
        let new_selected_test_title = selected_test_title.replace('/', '');
        let final_new_selected_swatch_title = new_selected_test_title.trimStart();
//         console.log(final_new_selected_swatch_title);
        
        for(let i=0; i<all_master_options.length; i++){
          if((all_master_options[i].getAttribute('master_title') == final_new_selected_swatch_title) && all_master_options[i].hasAttribute('disabled')){
//             console.log('sold out');
            document.getElementById('quickview-add-to-cart-btn').innerHTML = 'Sold Out';
            document.getElementById('quickview-add-to-cart-btn').style.pointerEvents = 'none';
            document.getElementById('quickview-add-to-cart-btn').style.backgroundColor = 'gray';
            break;
          }
          else if(all_master_options[i].getAttribute('master_title') == final_new_selected_swatch_title){
//             console.log('Available');
            document.getElementById('quickview-add-to-cart-btn').innerHTML = 'Add to Cart';
            document.getElementById('quickview-add-to-cart-btn').style.pointerEvents = 'initial';
            document.getElementById('quickview-add-to-cart-btn').style.backgroundColor = '#1d1d1d';
            break;
          }
          else{
//           	console.log('Unavailable');
            document.getElementById('quickview-add-to-cart-btn').innerHTML = 'Unavailable';
            document.getElementById('quickview-add-to-cart-btn').style.pointerEvents = 'none';
            document.getElementById('quickview-add-to-cart-btn').style.backgroundColor = 'gray';
            
          }
        }
        
        
      })
      


    }
    document.getElementById('quickviewPopup').style.display = "block";
    document.querySelector('body').style.overflow = "hidden";


    //   Close Quickview
    document.getElementById('quickview-close-btn').addEventListener('click', function(){

      //   Removing overlay div
      document.getElementById('quickview-popup-wrapper').style.display = "none";

      document.getElementById('featured-img-main').innerHTML = '';
      document.getElementById('secondary-imgs').innerHTML = '';
      document.getElementById('quickview-info').innerHTML = '';
      document.getElementById('quickviewPopup').style.display = "none";
      document.querySelector('body').style.overflow = "visible";

    });


    //   Add to cart btn

    document.getElementById('quickview-add-to-cart-btn').addEventListener('click', function(){

      //   get selecetd swatch and compare with master selector


      //     console.log(quickview_selected_swatch);
      let quickview_selected_swatch = document.querySelectorAll('.quickview-selected-swatch');
      let selected_swatch_title = '';
      quickview_selected_swatch.forEach((value, index)=>{

        selected_swatch_title = selected_swatch_title + ' / ' + value.querySelector('input').getAttribute('value');
      })

      let selected_swatch_title_temp = selected_swatch_title;
      let new_selected_swatch_title = selected_swatch_title_temp.replace('/', '');
      let final_new_selected_swatch_title = new_selected_swatch_title.trimStart();

      let quickview_add_to_cart_id = '';
      let quickview_add_to_cart_title = '';
      let quickview_add_to_cart_qty = Number(document.getElementById('quickview_cart_qty').value);
//       let cart_item_count = Number(document.querySelector('.cart-count-bubble span').textContent);
      let master_options = document.querySelectorAll('.variant_master_option');

      for(let i=0; i<master_options.length; i++){

        if(master_options[i].getAttribute('master_title') == final_new_selected_swatch_title){

          quickview_add_to_cart_id = master_options[i].getAttribute('value');
          quickview_add_to_cart_title = master_options[i].getAttribute('master_title');
        }
      }


      //     POST Data
      let formData = {
        'items': [{
          'id': quickview_add_to_cart_id,
          'quantity': quickview_add_to_cart_qty
        }]
      };


      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
//         console.log('POST:');
        return response.json();
      })
      .then(newRes =>{
// console.log(newRes);
        if(newRes.status == 422){
          
          document.getElementById('quickview-error-msg').style.display = "block"; 
          document.getElementById('quickview-error-msg').textContent = newRes.description;
          setTimeout(function(){ 
            document.getElementById('quickview-error-msg').style.display = "none"; 
          },5000);
        }
        
            
        else if(newRes.status == "bad_request"){
          document.getElementById('quickview-error-msg').style.display = "block"; 
          document.getElementById('quickview-error-msg').textContent = 'Please Select the Options';

        setTimeout(function(){ 
          document.getElementById('quickview-error-msg').style.display = "none"; 
        },2500);
        
        }
      
        else{
          fetch('/cart.js',{
            'method': 'GET',
          })
          .then(getResponse =>{
                return getResponse.json();
                  
          })
          .then(getData=>{
            
            if(document.querySelectorAll('.hide-red-circle').length > 0){
              document.querySelector('.hide-red-circle').classList.add('show-red-circle');
              document.querySelector('.hide-red-circle').classList.remove('hide-red-circle');
            }
            document.querySelector('.cart-count-bubble').querySelector('span').innerHTML = getData.item_count;
//           	console.log(getData);
          })
          document.getElementById('quickview-success-msg').style.display = "block"; 
          document.getElementById('quickview-success-msg').innerHTML = `You have added ${quickview_add_to_cart_qty}, ${newRes.items[0].title} to your <a id="quickview-cart-link" href="https://www.limelight.pk/cart">cart</a>`;
          
          setTimeout(function(){ 
              document.getElementById('quickview-success-msg').style.display = "none"; 
            },5000);
//           document.querySelector('.cart-count-bubble').querySelector('span').textContent = cart_item_count + quickview_add_to_cart_qty;

        }

      })
      .catch((error) => {
//         console.log('POST Error:');
        console.log(error);

      });


    });

  }
if(mainMenuMediaQuery.matches){
}


// faq page

let all_plus = document.querySelectorAll('.faq_plus');
let all_minus = document.querySelectorAll('.faq_minus');
let all_faq_qstn = document.querySelectorAll('.faq-qstn');

for(let i=0; i<all_faq_qstn.length; i++){
  all_faq_qstn[i].addEventListener('click', function(){
    
    if(all_faq_qstn[i].querySelector('.faq_plus').style.display == 'none'){
      all_faq_qstn[i].querySelector('.faq_plus').style.display = "inline-block";
      all_faq_qstn[i].querySelector('.faq_minus').style.display = "none";
      all_faq_qstn[i].closest('li').querySelector('.faq-ans').style.display = "none";
    }
    else{
      all_faq_qstn[i].querySelector('.faq_plus').style.display = "none";
      all_faq_qstn[i].querySelector('.faq_minus').style.display = "inline-block";
      all_faq_qstn[i].closest('li').querySelector('.faq-ans').style.display = "block";
    }
    
})
}

// product page radio buttons on mobile

if(document.querySelectorAll('.variant-radios-main').length > 0){
// 	console.log('product page');
  let all_swatches = document.querySelector('.variant-radios-main').querySelectorAll('fieldset').length;
  if(all_swatches > 1){
  	document.querySelector('.variant-radios-main').classList.add('more-swatch');
  }
  else{
  	document.querySelector('.variant-radios-main').classList.add('one-swatch');
  }
//   console.log(all_swatches);
}



// to close opend filter dropdown only on desktop

if(mainMenuMediaQuery.matches){
  if(document.querySelectorAll('#CollectionFiltersForm').length > 0){
    document.querySelector('body').addEventListener('click', function(e){
      let clicked_tag = e.target.tagName.toLowerCase();
//       console.log(clicked_tag);
      let all_dis = document.querySelectorAll('.facets__disclosure');
      if(clicked_tag == 'input' || clicked_tag == 'svg' || clicked_tag == 'label'){

      }
      else{
        for(let i=0; i<all_dis.length; i++){
          if(all_dis[i].hasAttribute('open')){
            all_dis[i].removeAttribute('open');
          }
        }
      }
    })
  }
}

// set empty html for desktop currency converter

// const after_desktop = window.matchMedia('(max-width: 990px)');
// if(after_desktop.matches) {
//   document.querySelector('.header__icons').querySelector('.currency-desktop').innerHTML= '';
// }

// Hiding Specific Filters on Specific Collection Page

if(window.location.href.includes('collections')){
  if(document.querySelectorAll('#CollectionProductGrid').length > 0){
    let current_collection = document.querySelector('#CollectionProductGrid').getAttribute('collection_handle');

    //   function to hide filter

    function toHideFilter(filter_name1,filter_name2,filter_name3,filter_name4,filter_name5){

      let all_facet_text = document.querySelectorAll('.cstm-facet-text');

      for(let i=0; i<all_facet_text.length; i++){
        if(all_facet_text[i].innerHTML.toLowerCase() == filter_name1){
          all_facet_text[i].closest('details').style.display = 'none';
        }
        if(all_facet_text[i].innerHTML.toLowerCase() == filter_name2){
          all_facet_text[i].closest('details').style.display = 'none';
        }
        if(all_facet_text[i].innerHTML.toLowerCase() == filter_name3){
          all_facet_text[i].closest('details').style.display = 'none';
        }
        if(all_facet_text[i].innerHTML.toLowerCase() == filter_name4){
          all_facet_text[i].closest('details').style.display = 'none';
        }
        if(all_facet_text[i].innerHTML.toLowerCase() == filter_name5){
          all_facet_text[i].closest('details').style.display = 'none';
        }
      }

    }

    //     Calling hide filter function for specific collections

 
    //    For bottoms collection
    if(current_collection == 'bottoms'){
      // toHideFilter('type');
    }
    
    //     For pants and jeggings
    else if(current_collection == 'bottoms-pants' || current_collection == 'jeggings'){
    	toHideFilter('type');
    }
    
    //     For tights and skirts
    else if(current_collection == 'tights' || current_collection == 'skirts'){
      toHideFilter('season', 'fabric', 'type');
    }
    
    //     For sleepwear
    // else if(current_collection == 'sleepwear'){
    //   toHideFilter('type');
    // }
    
    //   For Western
   // else if(current_collection == 'western-new'){
   //    toHideFilter('type');
   //  }
    
    //   For tops, jump suits, dresses
    // else if(current_collection == 'tops' || current_collection == 'western-jumpsuits' || current_collection == 'dresses'){
    //   toHideFilter('type');
    // }
   
    //   For tanktops 
    else if(current_collection == 'tank-tops'){
      toHideFilter('type','season','fabric','size','color');
    }
    
    //   For outerwear, t-shirts, co-ords 
    else if(current_collection == 'western-outerwear' || current_collection == 'western-t-shirt' || current_collection == 'co-ords'){
      toHideFilter('fabric');
    }
    // else if(current_collection == 'western-outerwear' || current_collection == 'western-t-shirt' || current_collection == 'co-ords'){
    //   toHideFilter('type','fabric');
    // }
    
    //   For women accessories 
    else if(current_collection == 'women-accessories'){
      toHideFilter('type','season','fabric','size','color');
    }
    
    //     For scarves
    // else if(current_collection == 'scarves' || current_collection == 'printed-scarf'){
    //   toHideFilter('type');
    // }
    
    //     For Duppatas and footwear sliders
    else if(current_collection == 'dupattas' || current_collection == 'sliders'){
      toHideFilter('type', 'season');
    }
    
    //     For Women Bags and its sub categories
    else if(current_collection == 'bags' || current_collection == 'handbags' || current_collection == 'shoulder-bags' || current_collection == 'clutches' || current_collection == 'casual-clutches' || current_collection == 'formal-clutches' || current_collection == 'makeup-pouches'){
      toHideFilter('season','fabric','size');
    }
    
    //     For Women footwear and its sub categories
    else if(current_collection == 'footwear' || current_collection == 'slippers' || current_collection == 'heels' || current_collection == 'wedges' || current_collection == 'flipflops' || current_collection == 'sandals' || current_collection == 'loafers' || current_collection == 'pumps' || current_collection == 'sneakers' || current_collection == 'boots' || current_collection == 'mules' || current_collection == 'slippers-1'){
      toHideFilter('season','fabric');
    }
    
    //     For bracelets
    else if(current_collection == 'bracelets'){
      toHideFilter('type');
    }

    //     For jewelery
    else if(current_collection == 'jewellery'){
      toHideFilter('type','season','color');
    }
    
    //   For sunglasses, hair, belts, keychains
    else if(current_collection == 'sunglasses' || current_collection == 'hair-accessories' || current_collection == 'belts' || current_collection == 'key-chains'){
      toHideFilter('season','fabric','size','type');
    }
    
    //   For Girls accessories
    else if(current_collection == 'girls-accessories'){
      toHideFilter('type','season','fabric','size','color');
    }
    
    //   For men kurta, shirts, suits
    // else if(current_collection == 'men-kurta' || current_collection == 'men-kurta-shalwar'){
    //   toHideFilter('type');
    // }
  
    
    //    For men trousers
    else if(current_collection == 'men-trousers'){
      toHideFilter('type','season','fabric');
    }
    
    //   For men perfumes  
    else if(current_collection == 'men-perfumes'){
      toHideFilter('type','season','fabric','size','color');
    }

    //    unstitched  
    else if(current_collection == 'unstitched'){
      toHideFilter('size');
    }
    
  }
}

// collection filter custom close sign

if(document.querySelectorAll('.filter-close-sign'.length > 0)){
  let all_cstm_filter_close = document.querySelectorAll('.filter-close-sign');
  for(let i=0; i<all_cstm_filter_close.length; i++){
    all_cstm_filter_close[i].addEventListener('click', function(){
      this.closest('details').removeAttribute('open');
    })
  }
}

$('#load-more-cstm-btn, #load-more-sbp').on('inview', function(event, isInView) {
  if (isInView) {
    // element is now visible in the viewport
    console.log("Element is now visible in the viewport", event)
    $('#load-more-cstm-btn').trigger('click');  
    $('#load-more-sbp').trigger('click');  
  } else {
    // element has gone out of viewport
    console.log("Element has gone out of viewport")
  }
});





  let phoneBtn = document.querySelector(".phone-modal-btn");
  let phonemodal = document.querySelector(".phone-mobile-call-wrapper");
  let phoneCloseBtn = document.querySelector(".mobile-call-moda-close");
    phoneBtn.addEventListener("click",function(){
      phonemodal.classList.add("modal-show")
    })
  
    phoneCloseBtn.addEventListener("click",function(){
      phonemodal.classList.remove("modal-show")
    })
  
